import { Badge, Card, Col, Container, Form, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Nav, Row } from "reactstrap";
import { Button, CardBody } from 'reactstrap';
import { useEffect, useState, useCallback, InputHTMLAttributes } from 'react';
import webservice from '../../../Service/webservice';
import { AesDecrypt, AesEncrypt, keyPromise } from "../../../Service/crypto";
import { ChevronLeft, ChevronRight, Edit, Eye, EyeOff, Trash2 } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import moment from "moment";
import MD5 from "crypto-js/md5";
import { ErrorMessage, Field, Formik } from "formik";
import * as Yup from 'yup';
import { useForm } from "react-hook-form";
import { forwardRef } from 'react'
import ReactPaginate from "react-paginate";
import { getUserData, Get_permission } from "./store";
import { useAppDispatch } from "../../../ReaduxToolkit/Hooks";
import websocket_webservice from '../../../Service/websocket_webservice'
import api from '../../../api';
import ColumnChooser, { ColumnOption, isColVisible } from "../../../Components/ColumnChooser/ColumnChooser";
import { useColumnPreferences } from "../../../hooks/useColumnPreferences";


interface DeleteRowData {
  id: string;
  firstName: string;
  lastName: string;
  emailId: string;
  UserName: string;
  UserType: string;
  Role: string;
  ActiveStatus: string;
  CompanyName: string;
  RefId: string;
  [key: string]: any; // Allow for additional fields

}


const CustomHeader = ({ menuActions, handleFilter, value, handlePerPage, rowsPerPage, columnOptions, savedColumns, onColumnsChange }: any) => {
  return (
    <div className='client-master-list-table-header w-100 py-2'>
      <Row>
        <Col lg='6' className='d-flex align-items-center px-0 px-lg-1'>
          <div className='d-flex align-items-center me-4 '>
            <label htmlFor='rows-per-page' className='me-2'>Rows per Page:</label>
            <Input
              type='select'
              id='rows-per-page'
              value={rowsPerPage}
              onChange={handlePerPage}
              className='form-control ms-50 larger-select '
            >
              <option value='10'>10</option>
              <option value='25'>25</option>
              <option value='50'>50</option>
            </Input>
          </div>
          {menuActions.includes('add') && (
            <Button tag={Link} to='/clientManagement/addClient' color='primary' className='ms-2 zoom-on-hover'>
              + Add Client User
            </Button>
          )}
        </Col>
        <Col
          lg='6'
          className='d-flex align-items-center justify-content-lg-end mt-lg-0 mt-1 px-0 px-lg-3'
        >
          <div className="mb-2 me-2">
            <ColumnChooser options={columnOptions} savedColumns={savedColumns} onChange={onColumnsChange} />
          </div>
          <InputGroup className="input-group-search mb-2 zoom-on-hover">
            <Input
              type="text"
              placeholder="🔍 Search...."
              value={value}
              onChange={(e) => handleFilter(e.target.value)}
              className="input-search"
            />
          </InputGroup>
        </Col>
      </Row>
    </div>
  );
};


const ClientManagement = () => {


  const navigate = useNavigate();


  const [scrollInnerModal, setScrollInnerModal] = useState<boolean>(false);
  const [filteredAuditData, setFilteredAuditData] = useState<any[]>([]);
  const [refid, setRefid] = useState<string | null>(null);
  const Username = localStorage.UserName;
  const Role = localStorage.Role;

  const [isOpen, setIsOpen] = useState(false);
  const action = { fromUser: true };
  const [eventId, setEventId] = useState<DeleteRowData[]>([]);
  const [eventId1, setEventId1] = useState(0);
  const selectedRowsPerPage: { [key: number]: DeleteRowData[] } = {};
  // const menuActions = ['add','delete'];

  const dispatch = useAppDispatch()
  const store = useSelector((state: any) => state.ClientManagement)
  const [value, setValue] = useState<string>('');
  const [sort, setSort] = useState<string>('asc');
  const [sortColumn, setSortColumn] = useState<any>('id'); // Example initial sort column
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [menuActions, setMenuActions] = useState<string>('');
  const UserType = localStorage.UserType;
  const Id = UserType === 'MOS' ? localStorage.id : localStorage.ClientId;
  const [localData, setLocalData] = useState<DeleteRowData[]>(store.data);



  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const defaultValues = {
    confirmPassword: "",
    newPassword: ""
  }

  const {
    handleSubmit,
    formState: { errors },
    reset,

    control, watch
  } = useForm({
    defaultValues,
  });

  const handleReset = () => {
    reset({
      confirmPassword: "",
      newPassword: ""
    })
    toggle()
  }
  interface FormValues {
    newPassword: string;
    confirmPassword: string;
  }

  const initialValues: FormValues = {
    newPassword: '',
    confirmPassword: '',
  };

  useEffect(() => {
    if (localStorage.id !== null) {
      dispatch(Get_permission(localStorage.id)).then((response) => {
        const res1 = response.payload;
        const Action = res1[0].Permission.filter(
          (item: any) => item.MenuKey === "CLIENT_MANAGEMENT"
        );
        setMenuActions(Action[0].MenuActions);
      });
    }
  }, [localStorage.id])



  const validationSchema = Yup.object().shape({
    newPassword: Yup.string().required('New Password field is required.'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), ''], 'Passwords must match')
      .required('This field is required.'),
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSave = (async (data: FormValues) => {
    const newPassword = data.newPassword
    const hashedPassword = MD5(newPassword).toString();
    const resetpassword: any = { hashedPassword, refid };
    const key = await keyPromise
    const EncParams = await AesEncrypt(key,resetpassword);
    await api.fetch('api/Authentication/ResetPassword', {
      method: 'POST',
      body: JSON.stringify(EncParams)
    })
      .then((response) => {
        toggle();
        if (response.ok) {
          Swal.fire({
            title: 'Insurance Verification',
            text: 'Password successfully changed',
            icon: 'success',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          }).then((result) => {
            if (result.isConfirmed) {
              navigate(`/Client`);
            }
          });
        } else {
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  });



  // useEffect(() => {
  //   dispatch(
  //     getUserData({
  //       Id,
  //       UserType,
  //       q: value,
  //       perPage: rowsPerPage,
  //       page: currentPage,
  //       sort,
  //       sortColumn
  //     })
  //   );
  // }, [dispatch, store.data.length]);

  // const [localData, setLocalData] = useState<DataItem[]>(store.data);

  // Optional: Extract fetchData outside if reused elsewhere
  const fetchData = async () => {
    try {
      if (Id && UserType) {
        const actionResult = await dispatch(
          getUserData({
            Id,
            UserType,
            q: value,
            perPage: rowsPerPage,
            page: currentPage,
            sort,
            sortColumn,
          })
        );

        const payload = actionResult.payload as { data: DeleteRowData[] };
        setLocalData(payload.data);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  // Fetch data on dependency changes
  useEffect(() => {
    fetchData();
  }, [dispatch, Id, UserType, rowsPerPage, currentPage, sort, sortColumn, value]);

  // Setup WebSocket for real-time updates
  useEffect(() => {
    if (!Id || !UserType) return;

    const socket = new WebSocket(`${websocket_webservice}ws/usermanagement/`);
    socket.onopen = () => console.log('WS open /ws/usermanagement');
    socket.onerror = (error) => console.error('WS error /ws/usermanagement', error);
    socket.onclose = (e) => console.warn('WS close /ws/usermanagement', e.code, e.reason);

    socket.onmessage = (event) => {
      const change = JSON.parse(event.data);

      setLocalData((prevData: DeleteRowData[]) =>
        prevData.map((item) =>
          item.id === change.documentKey._id.$oid
            ? { ...item, ...change.updateDescription.updatedFields }
            : item
        )
      );
    };

    // Cleanup WebSocket on unmount
    return () => {
      if (socket.readyState === WebSocket.OPEN) {
        socket.close();
      }
    };
  }, [Id, UserType, websocket_webservice]);


  const handleReloadTable = () => {
    dispatch(
      getUserData({
        Id,
        UserType,
        q: value,
        perPage: rowsPerPage,
        page: currentPage,
        sort,
        sortColumn
      })
    );
  };


  const handleFilter = (val: any) => {
    setValue(val)
    setCurrentPage(1)
    dispatch(
      getUserData({
        Id,
        UserType,
        q: val,
        perPage: rowsPerPage,
        page: currentPage,
        sort,
        sortColumn,
      })
    )
  }

  const handlePerPage = (e: any) => {
    setCurrentPage(1)
    dispatch(
      getUserData({
        Id,
        UserType,
        q: value,
        perPage: parseInt(e.target.value),
        page: currentPage,
        sort,
        sortColumn,
      })
    )
    setRowsPerPage(parseInt(e.target.value))
  }



  const handlePagination = (page: any) => {
    dispatch(
      getUserData({
        Id,
        UserType,
        q: value,
        perPage: rowsPerPage,
        page: page.selected + 1,
        sort,
        sortColumn,
      })
    )
    setCurrentPage(page.selected + 1)
  }


  const dataToRender = () => {
    const filters: any = {
      q: value
    };
    const isFiltered = Object.keys(filters).some(function (k) {
      return filters[k].length > 0;
    });

    if (localData.length > 0) {
      return localData;
    } else if (localData.length === 0 && isFiltered) {
      return [];
    } else {
      return store.allData.slice(0, rowsPerPage);
    }
  };

  const handleSort = (column: any, sortDirection: any) => {
    setSort(sortDirection)
    setSortColumn(column.sortField)
    dispatch(
      getUserData({
        Id,
        UserType,
        q: value,
        perPage: rowsPerPage,
        page: currentPage,
        sort: sortDirection,
        sortColumn: column.sortField
      })
    )
  }

  const CustomPagination = () => {
    const count = Number(Math.ceil(store.total / rowsPerPage))

    return (
      <ReactPaginate
        previousLabel={<ChevronLeft size={16} />}
        nextLabel={<ChevronRight size={16} />}
        breakLabel="..."
        pageCount={count || 1}
        onPageChange={handlePagination}
        forcePage={currentPage !== 0 ? currentPage - 1 : 0}
        containerClassName="pagination-container"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakClassName="page-item"
        breakLinkClassName="page-link"
        activeClassName="active"
      />
    )
  }



  const deleteClient = async (ids: any[]) => {
    const key = await keyPromise
    const EncParams = await AesEncrypt(key,ids);
    await api.fetch('api/ClientManagement/DeleteClientuser', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    });
  };

  const ViewAuditLog = async (row: any) => {
    const key = await keyPromise
    const Username = localStorage.UserName;
    const Userid = localStorage.id;
    const RefId = row.RefId;
    const Name = row.UserName;
    const Data = { Username, RefId, Name, Userid };
    const EncParams = await AesEncrypt(key,Data);
    const response = await api.fetch('api/clientmanagement/ViewAuditLog', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then((response) => response.json());
    return response;
  };

  const DeleteAuditLogdata = async (Data: any[]) => {

    const key = await keyPromise
    Data.forEach((item: any) => {
      item.Userid = localStorage.id;
      item.ParentUserId = localStorage.ParentUserId;
    });
    const EncParams = await AesEncrypt(key,Data);
    const response = await api.fetch('api/ClientManagement/DeleteAuditLog', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then((response) => response.json());
    return response;
  };

  const DeleteRow = async (rows: DeleteRowData[] | DeleteRowData) => {
    const deleteRows = async () => {
      const rowCount = Array.isArray(rows) ? rows.length : 1;
      Swal.fire({
        title: "Insurance Verification Platform",
        text: `Are you sure you want to delete ${rowCount} ${rowCount > 1 ? 'Record' : 'Record'}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger ms-1",
        },
        buttonsStyling: false,
        allowOutsideClick: false
      }).then(async function (result) {
        if (result.isConfirmed) {
          if (Array.isArray(rows)) {
            const ids = rows.map(row => row.id);
            const Data = rows.map(row => ({
              Username,
              RefId: row.RefId,
              Name: row.UserName
            }));
            await deleteClient(ids);
            await DeleteAuditLogdata(Data);
            // ✅ Remove deleted rows from localData
            setLocalData(prev => prev.filter(item => !ids.includes(item.id)));
          } else {
            const { id, UserName: Name, RefId } = rows;
            const Data = { Username, RefId, Name };
            await deleteClient([id]);
            await DeleteAuditLogdata([Data]);
            // ✅ Remove the deleted row from localData
            setLocalData(prev => prev.filter(item => item.id !== id));
          }
          fetchData()
          Swal.fire({
            icon: "success",
            title: "Insurance Verification Platform",
            text: "Client(s) have been deleted.",
            customClass: {
              confirmButton: "btn btn-success",
            },
            allowOutsideClick: false
          });
          handleReloadTable();
          setEventId1(0)
          setEventId([])
        }
      });
    };
    deleteRows();
  };

  const getAuditlogdata = async (data: any) => {
    const key = await keyPromise
    const EncParams = await AesEncrypt(key,data);
    const response = await api.fetch('api/ClientManagement/getAuditLogData', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then((response) => response.json());
    const TempData = await AesDecrypt(key,response);
    return TempData;
  };

  useEffect(() => {
    const fetchData = async () => {
      if (refid !== null) {
        const res = await getAuditlogdata(refid);
        setFilteredAuditData(res);
      }
    };
    fetchData();
  }, [refid]);




  interface BootstrapCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
    id: string;
  }
  // Handle individual row checkbox change
  const BootstrapCheckbox = forwardRef<HTMLInputElement, BootstrapCheckboxProps>(
    ({ id, ...props }, ref) => (
      <div style={{ position: 'relative', left: '10px' }}>
        <input type='checkbox' id={id} ref={ref} {...props} />
      </div>
    )
  );


  // Handle individual row checkbox change

  const handleChangecheck = useCallback(
    ({ selectedRows }: any) => {


      const selectedEventIds = [];
      selectedRows.forEach((row: any) => {
        selectedEventIds.push(row.id);
      });
      setEventId(selectedRows)
      setEventId1(selectedEventIds.length)
      if (!action.fromUser)
        return;
      selectedRowsPerPage[currentPage] = selectedRows;
    },
    [currentPage, selectedRowsPerPage, action.fromUser]);


  const Columns = [

    {
      id: "CompanyName",
      name: "Client Name",
      selector: (row: DeleteRowData) => row.CompanyName,
      sortable: true,
      width: "180px",
      wrap: true,
    },
    {
      id: "firstName",
      name: "First Name",
      selector: (row: DeleteRowData) => row.firstName,
      sortable: true,
      width: "140px",
    },
    {
      id: "lastName",
      name: "Last Name",
      selector: (row: DeleteRowData) => row.lastName,
      sortable: true,
      width: "140px",
    },
    {
      id: "emailId",
      name: "EmailId",
      selector: (row: DeleteRowData) => row.emailId,
      sortable: true,
      width: "260px",
      wrap: true,

    },
    {
      id: "UserName",
      name: "User Name",
      selector: (row: DeleteRowData) => row.UserName,
      sortable: true,
      width: "160px",
    },
    {
      id: "UserType",
      name: "User Type",
      selector: (row: DeleteRowData) => row.UserType,
      sortable: true,
      width: "140px",
    },
    {
      id: "Role",
      name: "Role",
      selector: (row: DeleteRowData) => row.Role,
      sortable: true,
      width: "100px",
    },
    {
      id: "ActiveStatus",
      name: "Active Status",
      selector: (row: DeleteRowData) => row.ActiveStatus,
      sortable: true,
      width: "180px",
    },
    {
      id: "Action",
      name: "Action",
      cell: (row: DeleteRowData) => (
        <>
          <Eye
            size={17}
            id='positionLeft'
            color='#09d5ff'
            onClick={() => {
              setScrollInnerModal(true);
              setRefid(row.RefId);
            }}
            style={{ cursor: 'pointer', marginRight: '10px' }}
          />
          {eventId1 <= 1 && (
            menuActions.includes("edit") && (
              <Edit
                size={17}
                id='editIcon'
                color='#FFA500'
                onClick={() => {
                  navigate(`/clientManagement/editClient`);
                  localStorage.setItem("ClientEdit", row.RefId);
                  ViewAuditLog(row);
                }}
                style={{ cursor: 'pointer', marginRight: '10px' }}
              />
            )
          )}

          {eventId1 === 0 && (
            menuActions.includes("delete") && (
              <Trash2
                size={17}
                id='deleteIcon'
                color='#FF0000'
                onClick={() => DeleteRow(row)}
                style={{ cursor: 'pointer' }}
              />
            )
          )}
        </>
      ),
    },
  ];


  if (Role === 'Admin' || 'Super Admin') {
    const passwordColumn: any = {
      id: 'Password',
      sortable: true,
      name: 'Password',
      selector: (row: DeleteRowData) => (
        <div className="badge-icon">
          <Badge
            style={{ cursor: 'pointer' }}
            className="badge-button "
            onClick={() => {
              setRefid(row.RefId);
              setIsOpen(true);
            }}
          >
            Reset
          </Badge>
        </div>
      )
    };
    Columns.splice(8, 0, passwordColumn);
  }

  const { savedColumns, saveColumns } = useColumnPreferences('ClientUserListing');
  const columnOptions: ColumnOption[] = Columns.map((c: any) => ({ id: c.id, label: c.name, locked: c.id === 'CompanyName' || c.id === 'Action' }));
  const visibleColumns = Columns.filter((c: any) => isColVisible(columnOptions, savedColumns, c.id));

  const customStyles = {
    rows: {
      style: {
        '&:hover': {
          backgroundColor: '#f0f0f0',

        },
      },
    },
    headCells: {
      style: {
        backgroundColor: '#355876',  // Change background color of headers
        color: 'white',  // Change text color of headers
        fontSize: '16px',  // Adjust font size of headers
      },
    },
  };



  const startIndex = (currentPage - 1) * rowsPerPage + 1;
  const endIndex = Math.min(currentPage * rowsPerPage, store.total);
  const CustomLoadingComponent = () => {
    return (
      <div className="">
        {store.no_Data === 'There is no Record Found' ? (
          <h4>
            <br />
            <p>There are no records to display</p>
          </h4>
        ) : (
          <div className="custom-loader">
            <label className="custom-label">Please wait...</label>
            <div className="custom-loading"></div>
          </div>
        )}
      </div>
    );
  };


  return (
    <>
      {/* <Breadcrumbs mainTitle='Client Management' title='Client Management'/> */}
      <Container fluid>
        <div>
          <Modal isOpen={isOpen} toggle={toggle} className='modal-dialog-centered ' backdrop="static" >
            <ModalHeader style={{ fontWeight: 'bold' }}>Change Password</ModalHeader>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values: any) => handleSave(values)}
            >
              {({ handleSubmit }) => (
                <Form onSubmit={handleSubmit}>
                  <ModalBody>
                    <Col>
                      <Label for="newPassword">New Password<span style={{ color: 'red' }}>*</span></Label>
                      <InputGroup>
                        <Field name="newPassword" placeholder="Enter your New Password" type={showPassword ? 'text' : 'password'} className="form-control" />
                        <InputGroupText className="cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
                          {showPassword ? <EyeOff size={14} style={{ cursor: 'pointer' }} /> : <Eye size={14} style={{ cursor: 'pointer' }} />}
                        </InputGroupText>
                      </InputGroup>
                      <ErrorMessage name="newPassword" component="span" className="text-danger" />
                    </Col>
                    <br />
                    <Col>
                      <Label for="confirmPassword">Confirm Password<span style={{ color: 'red' }}>*</span></Label>
                      <InputGroup>
                        <Field name="confirmPassword" placeholder=" Re-Enter your Password" type={showConfirmPassword ? 'text' : 'password'} className="form-control" />
                        <InputGroupText className="cursor-pointer" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                          {showConfirmPassword ? <EyeOff size={14} style={{ cursor: 'pointer' }} /> : <Eye size={14} style={{ cursor: 'pointer' }} />}
                        </InputGroupText>
                      </InputGroup>
                      <ErrorMessage name="confirmPassword" component="span" className="text-danger" />
                    </Col>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="primary" type="submit">
                      Save
                    </Button>
                    <Button color="danger" type="reset" onClick={handleReset}>
                      Cancel
                    </Button>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </Modal>
        </div>
        <div>
          <Modal style={{ maxWidth: '1500px', maxHeight: '600px' }} isOpen={scrollInnerModal} toggle={() => setScrollInnerModal(!scrollInnerModal)} className='modal-dialog-centered modal-lg'>
            <ModalHeader toggle={() => setScrollInnerModal(!scrollInnerModal)}>Client Management Audit Log</ModalHeader>
            <ModalBody>
              <div style={{ maxHeight: '600px', overflow: 'auto' }}>
                <table className="audit-table-fixed" style={{ borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#f2f2f2' }}>
                      <th className="audit-tableHeaderStyle" style={{ width: '12%' }}>Date & Time</th>
                      <th className="audit-tableHeaderStyle" style={{ width: '5%' }}>Action</th>
                      <th className="audit-tableHeaderStyle" style={{ width: '73%' }}>Data Set</th>
                      <th className="audit-tableHeaderStyle" style={{ width: '10%' }}>Changed By</th>
                    </tr>
                  </thead>
                  <tbody style={{ alignItems: 'center' }}>
                    {filteredAuditData &&
                      filteredAuditData
                        .sort((a: any, b: any) => new Date(b.Modified).getTime() - new Date(a.Modified).getTime())
                        .map((item: any, index: number) => (
                          <tr key={index}>
                            <td className="audit-tableDataStyle">
                              {(() => {
                                const localDate = moment.utc(item.Modified).local().format('MM/DD/YYYY hh:mm:ss A');
                                return localDate;
                              })()}
                            </td>
                            <td className="audit-tableDataStyle">{item.Action}</td>
                            <td className="audit-tableDataStyle">
                              {item.Action === 'VIEW' ? (
                                <span>{item.JsonData}</span>
                              ) : (
                                <table className="audit-nested-table" style={{ borderCollapse: 'collapse' }}>
                                  <thead>
                                    <tr style={{ backgroundColor: '#f2f2f2' }}>
                                      <th className="audit-tableHeaderStyle" style={{ width: '20%' }}>Field</th>
                                      {item.Action === 'EDIT' && (
                                        <>
                                          <th className="audit-tableHeaderStyle" style={{ width: '40%' }}>Before</th>
                                          <th className="audit-tableHeaderStyle" style={{ width: '40%' }}>After</th>
                                        </>
                                      )}
                                      {item.Action === 'ADD' && (
                                        <th className="audit-tableHeaderStyle" style={{ width: '80%' }}>Value</th>
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {item.JsonData
                                      .sort((a: any, b: any) => a.field.localeCompare(b.field))
                                      .map((dataItem: any, dataIndex: number) => (
                                        <tr key={dataIndex}>
                                          <td className="audit-tableDataStyle">{dataItem.field}</td>
                                          {item.Action === 'EDIT' && (
                                            <>
                                              <td className="audit-tableDataStyle">
                                                {dataItem.field === 'Permission' && Array.isArray(dataItem.before) ? (
                                                  <table style={{ width: '100%' }}>
                                                    <thead>
                                                      <tr>
                                                        <th className="audit-tableHeaderStyle">Menu</th>
                                                        <th className="audit-tableHeaderStyle">Actions</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {dataItem.before.map((permission: any) => (
                                                        <tr key={permission.MenuLabel}>
                                                          <td className="audit-tableDataStyle">{permission.MenuLabel}</td>
                                                          <td className="audit-tableDataStyle">
                                                            {Array.isArray(permission.MenuActions)
                                                              ? permission.MenuActions.join(', ')
                                                              : permission.MenuActions}
                                                          </td>
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </table>
                                                ) : (
                                                  <div className="audit-cell-truncate" onClick={(e) => e.currentTarget.classList.toggle('expanded')} title={String((dataItem.before && dataItem.before.value) || dataItem.before || '')}>
                                                    {(dataItem.before && dataItem.before.value) || dataItem.before}
                                                  </div>
                                                )}
                                              </td>
                                              <td className="audit-tableDataStyle">
                                                {dataItem.field === 'Permission' && Array.isArray(dataItem.after) ? (
                                                  <table style={{ width: '100%' }}>
                                                    <thead>
                                                      <tr>
                                                        <th className="audit-tableHeaderStyle">Menu</th>
                                                        <th className="audit-tableHeaderStyle">Actions</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {dataItem.after.map((permission: any) => (
                                                        <tr key={permission.MenuLabel}>
                                                          <td className="audit-tableDataStyle">{permission.MenuLabel}</td>
                                                          <td className="audit-tableDataStyle">
                                                            {Array.isArray(permission.MenuActions)
                                                              ? permission.MenuActions.join(', ')
                                                              : permission.MenuActions}
                                                          </td>
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </table>
                                                ) : (
                                                  <div className="audit-cell-truncate" onClick={(e) => e.currentTarget.classList.toggle('expanded')} title={String((dataItem.after && dataItem.after.value) || dataItem.after || '')}>
                                                    {(dataItem.after && dataItem.after.value) || dataItem.after}
                                                  </div>
                                                )}
                                              </td>
                                            </>
                                          )}
                                          {item.Action === 'ADD' && (
                                            <td className="audit-tableDataStyle">
                                              {dataItem.field === 'Password' || dataItem.field === 'Pin' ? (
                                                '******'
                                              ) : dataItem.field === 'Permission' && Array.isArray(dataItem.value) ? (
                                                <table style={{ width: '100%' }}>
                                                  <thead>
                                                    <tr>
                                                      <th className="audit-tableHeaderStyle">Menu</th>
                                                      <th className="audit-tableHeaderStyle">Actions</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {dataItem.value.map((permission: any) => (
                                                      <tr key={permission.MenuLabel}>
                                                        <td className="audit-tableDataStyle">{permission.MenuLabel}</td>
                                                        <td className="audit-tableDataStyle">
                                                          {Array.isArray(permission.MenuActions)
                                                            ? permission.MenuActions.join(', ')
                                                            : permission.MenuActions}
                                                        </td>
                                                      </tr>
                                                    ))}
                                                  </tbody>
                                                </table>
                                              ) : (
                                                <div className="audit-cell-truncate" onClick={(e) => e.currentTarget.classList.toggle('expanded')} title={String((dataItem.value && dataItem.value.value) || dataItem.value || '')}>
                                                  {(dataItem.value && dataItem.value.value) || dataItem.value}
                                                </div>
                                              )}
                                            </td>
                                          )}
                                        </tr>
                                      ))}
                                  </tbody>
                                </table>
                              )}
                            </td>
                            <td className="audit-tableDataStyle">{item.UserName}</td>
                          </tr>
                        ))}
                  </tbody>
                </table>
              </div>
            </ModalBody>
          </Modal>
        </div>
        <Row>
          <Col sm={12}>
            <Card >
              <CardBody>
                <div className="table-responsive">
                  <div className="dataTables_wrapper">
                    <DataTable
                      persistTableHead
                      subHeader={true}
                      responsive={true}
                      onSort={handleSort}
                      data={dataToRender()}
                      columns={visibleColumns}
                      paginationServer
                      customStyles={customStyles}
                      paginationPerPage={rowsPerPage}
                      paginationDefaultPage={currentPage}
                      selectableRows
                      selectableRowsHighlight
                      selectableRowsComponent={BootstrapCheckbox as unknown as React.ReactNode}
                      onSelectedRowsChange={handleChangecheck}
                      paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                      noDataComponent={<CustomLoadingComponent />}
                      paginationComponent={CustomPagination}
                      subHeaderComponent={
                        <CustomHeader
                          value={value}
                          menuActions={menuActions}
                          rowsPerPage={rowsPerPage}
                          handleFilter={handleFilter}
                          handlePerPage={handlePerPage}
                          columnOptions={columnOptions}
                          savedColumns={savedColumns}
                          onColumnsChange={saveColumns}
                        />
                      }
                    />
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ paddingLeft: '2%' }}>
                        {store.total && (
                          <span><strong>{`${startIndex} to ${endIndex} of ${store.total} entries`}</strong></span>
                        )}
                      </div>
                      <div>
                        <CustomPagination />
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
            <div>
              {eventId1 > 0 && menuActions.includes('delete') && (
                <div className="customizer-links open">
                  <Nav className=" flex-column nav-pills">
                    <a className="nav-link" onClick={() => DeleteRow(eventId)}>
                      <span>Delete</span>
                      <Trash2 className="trash-icon" size={20} />
                    </a>
                  </Nav>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ClientManagement;
